import { queries } from '@/shared/lib/tanstack-query/query-keys'
import { useQueries } from '@tanstack/react-query'

export const useProductDetailInfo = (id: string) => {
  return useQueries({
    queries: [queries.products.detail(id), queries.products.options(id)],
    combine: (results) => {
      const detail = results[0].data
      if (!detail) return { pending: true, data: null }
      const options = results[1].data
      return {
        pending: results.some((result) => result.isPending),
        data: {
          title: detail.title,
          tags: detail.tags,
          rating: detail.rating,
          options: options?.results,
          highestPrice: detail.price.priceHighest,
          eachPrice: detail.price.eachPrice,
          currentPrice: detail.price.price,
          ratingCount: detail.ratingCount,
          diffRate: detail.price.diffRate,
          weightInfo: detail.weightInfo,
          discountCards: detail.discountCards,
          deliveryImageUrl: detail.deliveryImageUrl,
        },
      }
    },
  })
}
